import { FUNDERS, CLIENT_FUNDERS } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';

export interface FunderProperties {
	id: string;
	name: string;
}

export interface ClientFunderProperties {
	id: string;
	clientId: string;
	funderId: string;
	funderName: string;
	isActive: boolean;
	createdAt: string;
}

export interface CreateClientFunderProperties {
	clientId: string;
	funderId: string;
}

export const Funding = {
	getFunders: () =>
		FetchAPI.getJson({
			urlStr: FUNDERS,
		}),
	getClientFunders: (clientId: string) =>
		FetchAPI.getJson({
			urlStr: CLIENT_FUNDERS(clientId),
		}),
	addClientFunder: (data: CreateClientFunderProperties) =>
		FetchAPI.postJson({
			urlStr: CLIENT_FUNDERS(data.clientId),
			data,
		}),
	removeClientFunder: (clientId: string, clientFunderId: string) =>
		FetchAPI.deleteJson({
			urlStr: `${CLIENT_FUNDERS(clientId)}/${clientFunderId}`,
		}),
};
